import React, { useState } from "react";
import { NoEmployees } from "../../employees/components/NoEmployees";
import { TableActiveDateRange } from "../../common/components/TableDateRange";
import { LinkEmployee } from "../../employees/Routes";
import { useQueryWithPagination } from "../../utils/Hooks";
import { AxiosEmployeeAreaAPI } from "../../common/Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";

const AreaEmployeeTable = ({ employeearea_set, ordering, setOrdering }) => {
  if (employeearea_set.length === 0) {
    return <NoEmployees message="Não há funcionários ativos nesta área!" />;
  }

  const rows = employeearea_set.map((el) => ({
    id: el.id,
    name: <LinkEmployee employee={el.employee} />,
    startDate: el.timespan.lower,
  }));

  return (
    <TableActiveDateRange
      recordName={"Funcionário"}
      data={rows}
      ordering={ordering}
      setOrdering={setOrdering}
      nameColumn="employee"
    />
  );
};

export const AreaEmployeeList = ({ area_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { isPending, data, error, handlePrevious, handleNext } =
    useQueryWithPagination({
      queryKey: ["area-employee-list", area_id, ordering],
      queryFn: AxiosEmployeeAreaAPI.getForArea,
      area_id: area_id,
      ordering: ordering,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <AreaEmployeeTable
          employeearea_set={data.results}
          ordering={ordering}
          setOrdering={setOrdering}
        />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
